import React, { useEffect, useState } from "react";
import { FileText, Calendar } from "lucide-react";
import { portalApi } from "../../lib/portalApi";
import { brl } from "../../lib/format";
import { useI18n } from "../../i18n/I18nContext";

function fmt(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleDateString("en-US", {
    day: "2-digit", month: "short", year: "numeric",
  });
}

const STATUS_MAP = {
  pendente: ["Pendente", "bg-amber-50 text-amber-800 border-amber-200"],
  aprovado: ["Aprovado", "bg-emerald-50 text-emerald-800 border-emerald-200"],
  rejeitado: ["Rejeitado", "bg-rose-50 text-rose-800 border-rose-200"],
};

export default function PortalEstimates() {
  const { t } = useI18n();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await portalApi.get("/portal/estimates");
        setItems(data);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  if (loading) return <div className="text-slate-500 text-sm">{t("Carregando…")}</div>;

  if (items.length === 0) {
    return (
      <div className="space-y-5" data-testid="portal-estimates">
        <h1 className="text-2xl font-bold text-slate-900">{t("Orçamentos")}</h1>
        <div className="rounded-2xl border border-dashed border-slate-300 bg-white p-8 text-center text-slate-500">
          {t("Nenhum orçamento vinculado ao seu e-mail.")}
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-5" data-testid="portal-estimates">
      <h1 className="text-2xl font-bold text-slate-900">{t("Orçamentos")}</h1>

      <ul className="space-y-3">
        {items.map((e) => {
          const [label, cls] = STATUS_MAP[e.status] || [e.status || "—", "bg-slate-100 text-slate-700 border-slate-200"];
          return (
            <li
              key={e.id}
              data-testid={`portal-estimate-${e.id}`}
              className="bg-white rounded-2xl border border-slate-200 p-4 flex flex-wrap items-center justify-between gap-3"
            >
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-xl bg-blue-50 border border-blue-200 flex items-center justify-center text-blue-700">
                  <FileText size={18} />
                </div>
                <div>
                  <div className="text-sm font-semibold text-slate-900 flex items-center gap-1">
                    <Calendar size={13} /> {fmt(e.created_at)}
                  </div>
                  <div className="text-xs text-slate-600 truncate max-w-md">{e.address || "—"}</div>
                </div>
              </div>
              <div className="flex flex-col items-end gap-1">
                <span className={`text-[11px] font-semibold px-2 py-0.5 rounded-full border ${cls}`}>{t(label)}</span>
                <div className="font-bold text-slate-900 text-lg">{brl(e.total_value)}</div>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
